
import React from 'react';
import ComTitle from '@/components/comTitle';
import Item from './item';
import './index.scss';


function Fare({
    info
}) {
    return (
        <div className='home-fare'>
            <ComTitle title='更多福利' />
            <div className='home-fare-box'>
                {
                    info.map((it, idx) => <Item info={it} current={idx} key={idx} />)
                }
            </div>
        </div>
    )
}


export default React.memo(Fare);